(function () {
  'use strict';

  var SP_VARIANT_ID = '50256929882332';
  var SP_SESSION_KEY = 'aonic_sp_opted_out';
  var pendingCartOp = null;
  var checkoutIntercepted = false;

  function addToCart() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: SP_VARIANT_ID, quantity: 1 })
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed: ' + res.status);
      return res.json();
    });
  }

  function removeFromCart() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: { [SP_VARIANT_ID]: 0 } })
    }).then(function (res) {
      if (!res.ok) throw new Error('update failed: ' + res.status);
      return res.json();
    });
  }

  function isOptedOut() {
    try { return sessionStorage.getItem(SP_SESSION_KEY) === '1'; } catch (e) { return false; }
  }

  function setOptedOut(val) {
    try { sessionStorage.setItem(SP_SESSION_KEY, val ? '1' : '0'); } catch (e) {}
  }

  function refreshCartSection() {
    var cartItemsEl = document.querySelector('cart-items-component');
    var sectionId = cartItemsEl && cartItemsEl.dataset.sectionId;

    if (sectionId) {
      var sectionsUrl = window.location.pathname === '/cart' ? '/cart' : '/';
      fetch(sectionsUrl + '?sections=' + sectionId, {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections[sectionId];
          if (html && cartItemsEl) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newCartItems = doc.querySelector('cart-items-component');
            if (newCartItems) {
              cartItemsEl.innerHTML = newCartItems.innerHTML;
              return;
            }
          }
          // Silent fail — update subtotal text only
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var totalEl = document.querySelector('[data-cart-subtotal]');
            if (totalEl) {
              var formatted = (cart.total_price / 100).toFixed(2);
              totalEl.textContent = totalEl.textContent.replace(/[\d,]+\.?\d*/, formatted);
            }
          });
        })
        .catch(function () {
          // Silent fail — keep drawer open
        });
    }
  }

  function interceptCheckout() {
    if (checkoutIntercepted) return;
    checkoutIntercepted = true;

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.id !== 'cart-form') return;
      var submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;

      var widget = document.getElementById('aonic-shipping-protection');
      var checkbox = widget && widget.querySelector('#sp-toggle-checkbox');
      if (!checkbox || !checkbox.checked) return; // opted out

      var inCart = widget && widget.dataset.inCart === 'true';
      if (inCart && !pendingCartOp) return; // already confirmed in cart

      e.preventDefault();
      e.stopImmediatePropagation();

      var waitFor = pendingCartOp || addToCart();
      pendingCartOp = waitFor;

      function proceed() {
        pendingCartOp = null;
        if (widget) widget.dataset.inCart = 'true';
        window.location.href = '/checkout';
      }

      waitFor.then(proceed).catch(function (err) {
        console.error('[ShippingProtection] Checkout add failed:', err);
        pendingCartOp = null;
        window.location.href = '/checkout';
      });
    }, true); // capture phase
  }

  function initWidget(widget) {
    if (!widget || widget.dataset.spInit) return;
    widget.dataset.spInit = '1';

    var checkbox = widget.querySelector('#sp-toggle-checkbox');
    if (!checkbox) return;

    var inCart = widget.dataset.inCart === 'true';
    var optedOut = isOptedOut();

    // Auto-add logic:
    // - Only fire if NOT opted out in this session
    // - AND item is not already in cart
    // - AND toggle is not already checked (Liquid would set checked=true if in cart)
    if (!optedOut && !inCart) {
      // First visit or session reset — auto-add and check the toggle
      checkbox.checked = true;
      pendingCartOp = addToCart()
        .then(function (data) {
          if (data && data.status && data.status !== 200) {
            console.warn('[ShippingProtection] Auto-add failed:', data.description || data.message);
            checkbox.checked = false;
          } else {
            widget.dataset.inCart = 'true';
            setOptedOut(false);
            refreshCartSection();
          }
          pendingCartOp = null;
        })
        .catch(function (err) {
          console.warn('[ShippingProtection] Auto-add error:', err);
          checkbox.checked = false;
          pendingCartOp = null;
        });
    } else if (inCart) {
      // Item is in cart — ensure toggle reflects that
      checkbox.checked = true;
    }
    // If optedOut && !inCart — leave checkbox unchecked (Liquid renders it unchecked)

    checkbox.addEventListener('change', function () {
      var checked = checkbox.checked;
      widget.classList.add('sp-widget--loading');
      checkbox.disabled = true;

      var promise = checked ? addToCart() : removeFromCart();
      pendingCartOp = promise;

      promise
        .then(function () {
          pendingCartOp = null;
          widget.dataset.inCart = checked ? 'true' : 'false';
          setOptedOut(!checked); // track opt-out state in sessionStorage
          widget.classList.remove('sp-widget--loading');
          checkbox.disabled = false;
          refreshCartSection();
        })
        .catch(function (err) {
          console.error('[ShippingProtection] AJAX error:', err);
          pendingCartOp = null;
          checkbox.checked = !checked;
          widget.classList.remove('sp-widget--loading');
          checkbox.disabled = false;
        });
    });
  }

  function scanAndInit() {
    var widget = document.getElementById('aonic-shipping-protection');
    if (widget) initWidget(widget);
  }

  // Run immediately in case widget is already in DOM
  scanAndInit();

  // Register checkout interception once
  interceptCheckout();

  // Watch for widget being injected into DOM (cart drawer open / section morph)
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.id === 'aonic-shipping-protection') {
          initWidget(node);
        } else if (node.querySelector) {
          var found = node.querySelector('#aonic-shipping-protection');
          if (found) initWidget(found);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
